// Implements: F-UIX-014, F-UIX-015, F-MCK-002, F-MCK-017, F-UIX-023
/**
 * `/` — the gallery (UX-07): where mockups are found, organised and shared. Creating lives in the
 * Lienzo, reached from the topbar's "Nuevo mockup".
 *
 * The page only composes: the pages, the filters, the mutations, the trash and their notices live in
 * the `mockups` containers (F-UIX-009).
 */

import type { ReactElement } from "react";
import { Link } from "react-router";

import { GalleryBrowserContainer } from "../../modules/mockups/containers/GalleryBrowserContainer";
import { useTranslation } from "../../shared/i18n";
import { buttonClassName } from "../../shared/ui/atoms/Button";
import { Icon } from "../../shared/ui/atoms/Icon";
import { PageHeader } from "../../shared/ui/molecules/PageHeader";
import { PageActions } from "../layout/Topbar";

export function GalleryPage(): ReactElement {
  const { t } = useTranslation();
  return (
    <section>
      <PageHeader title={t("gallery.title")} subtitle={t("gallery.subtitle")} />
      <PageActions>
        <Link className={buttonClassName("primary")} to="/lienzo">
          <Icon name="plus" size="sm" />
          {t("lienzo.newMockup")}
        </Link>
      </PageActions>
      <GalleryBrowserContainer />
    </section>
  );
}
